import axios from 'axios';
import myShopClient from './nearlive';

export async function getMyShops() {
	const client = await myShopClient();
	const { data } = await client.get('/api/my-shop');
	const shops = data?.shops ?? data;
	return Array.isArray(shops) ? shops : [];
}

export async function getMyShopsWithDisabled() {
	const client = await myShopClient();
	const { data } = await client.get('/api/my-shop');
	if (Array.isArray(data)) {
		return { shops: data, disabledShops: [] };
	}
	return {
		shops: Array.isArray(data?.shops) ? data.shops : [],
		disabledShops: Array.isArray(data?.disabledShops) ? data.disabledShops : []
	};
}

export async function getHubspotAuth() {
	const client = await myShopClient();
	const { data } = await client.get('/api/hubspot-auth');
	return data;
}

export async function updateMyShop(id, update) {
	const client = await myShopClient();
	const { data } = await client.put(`/api/my-shop/${id}`, update);
	return data;
}

export async function setQuantityBuffer(shopId, quantityBuffer) {
	const client = await myShopClient();
	// If shopId is provided, update single shop; otherwise update all shops in organisation
	const endpoint = shopId ? `/api/inventory/${shopId}/quantity-buffer` : '/api/inventory/quantity-buffer';
	const { data } = await client.put(endpoint, { quantityBuffer });
	return data;
}

export async function updateLastLogin() {
	const client = await myShopClient();
	await client.put(`/api/last-login`);
}

export async function saveFileToS3(id, file, { field } = {}) {
	const client = await myShopClient();
	const params = { filename: file.name, shopUUID: id, ContentType: file.type };
	if (field) params.field = field;
	const query = new URLSearchParams(params);
	const {
		data: { url }
	} = await client.get(`/api/upload-image?${query.toString()}`);
	await axios.put(url, file, { headers: { 'Content-Type': file.type } });
	return url.split('?')[0];
}

export default {
	getMyShops,
	getMyShopsWithDisabled,
	getHubspotAuth,
	updateMyShop,
	setQuantityBuffer,
	saveFileToS3,
	updateLastLogin
};
